import React, { useState } from "react";
import { set, useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import httpServices from "../../../services/httpServices";
import { useUser } from "../../../context/UserContext";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import LoadingOverlay from "../../../component/common/overlay";

const schema = Yup.object().shape({
  venueName: Yup.string().required("Venue name is required"),
  venueDescription: Yup.string()
    .min(50, "Description must be at least 50 characters")
    .max(500, "Description cannot exceed 500 characters")
    .required("Description is required"),
});

function VenueDetails({ setActiveStep, setVenueId, venueData }) {

  const { user } = useUser();
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: venueData,
  });

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      if (venueData && venueData?.stepsDone !== 0) {
        const { response, error } = await httpServices.put(
          `/venue/update/${venueData?.id}`,
          {
            ...data,
            userId: user?.userId,
          }
        );

        if (error) {
          throw error;
        }

        if (response.status === 200) {
          toast.success("Venue details updated successfully");
        }
      } else {
        console.log("data", data);
        const { response, error } = await httpServices.post("/venue/create", {
          ...data,
          userId: user.userId,
          stepsDone: 1,
        });
        if (error) {
          throw error;
        }
        if (response.status === 201) {
          const id = response?.data?.data?.id;
          setActiveStep(1);
          setVenueId(id);
        }
      }
    } catch (error) {
      console.log("Error", error);
      toast.error(error?.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="mt-3 p-3 bg-white relative">
        {loading && <LoadingOverlay />}
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row ">
            <div className="col-lg-7 col-12">
              <div>
                <h3 className="text-blue fw-semibold text-xl mb-4">
                  Venue Details
                </h3>
                <div className="mb-3">
                  <label
                    htmlFor="venueName"
                    className="font-medium text-base mb-2"
                  >
                    Venue name*
                  </label>
                  <input
                    type="text"
                    placeholder="AJ Ballroom Section 2"
                    className={`custom-input bg-[#F5F6FA] ${
                      errors.venueName ? "border-red-500" : ""
                    }`}
                    {...register("venueName")}
                  />
                  {errors.venueName && (
                    <p className="text-red-500 text-sm">
                      {errors.venueName.message}
                    </p>
                  )}
                </div>
                <div className="mb-3">
                  <label
                    htmlFor="venueDescription"
                    className="font-medium text-base mb-2"
                  >
                    Describe your venue*
                  </label>
                  <textarea
                    className={`custom-input bg-[#F5F6FA] ${
                      errors.venueDescription ? "border-red-500" : ""
                    }`}
                    placeholder="Add venue description of up to 50-500 characters"
                    {...register("venueDescription")}
                    rows="10"
                    cols="30"
                  ></textarea>
                  {errors.venueDescription && (
                    <p className="text-red-500 text-sm">
                      {errors.venueDescription.message}
                    </p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-lg-5 col-12">
              <div className="flex flex-col justify-center items-center gap-4 p-4 bg-[#F5F6FA]">
                <p className="text-base font-normal">
                  Want to skip the hassle of creating a venue? Drop us an
                  enquiry and we’ll setup for you.
                </p>
                <img src="/images/create-venue.svg" alt="" />
                <button className="auth-button bg-[#407BFF] w-50 justify-center">
                  Enquire
                </button>
              </div>
            </div>
          </div>
          <div className="h-48 flex justify-center items-end">
            <button type="submit" className="gradian-btn text-white px-3 py-2">
              Save & Proceed
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default VenueDetails;
